import { Icon } from '@iconify/react'

export const PERIODS = [
    { value: 1, label: '24 h' },
    { value: 7, label: '7 jours' },
    { value: 30, label: '30 jours' },
]

export const SORTS = [
    { value: 'recent', label: 'Plus récents' },
    { value: 'area', label: 'Plus étendus' },
]

const FilterPanel = ({
    days, onDaysChange,
    query, onQueryChange,
    regions, activeRegions, onToggleRegion,
    sources, activeSources, onToggleSource,
    sort, onSortChange,
    onReset, isFiltered,
}) => (
    <div className="filters">
        <div className="filters__row">
            <label className="field__label" htmlFor="search">Rechercher</label>
            <div className="search">
                <Icon icon="mdi:magnify" aria-hidden="true" />
                <input
                    id="search"
                    type="search"
                    placeholder="Lieu, pays, identifiant…"
                    value={query}
                    onChange={e => onQueryChange(e.target.value)}
                />
            </div>
        </div>

        <div className="filters__row">
            <span className="field__label">Période observée</span>
            <div className="segmented" role="group" aria-label="Période observée">
                {PERIODS.map(p => (
                    <button
                        key={p.value}
                        type="button"
                        className={`segmented__item${days === p.value ? ' is-active' : ''}`}
                        aria-pressed={days === p.value}
                        onClick={() => onDaysChange(p.value)}
                    >
                        {p.label}
                    </button>
                ))}
            </div>
        </div>

        <div className="filters__row">
            <span className="field__label">Régions</span>
            <div className="chips">
                {regions.map(r => (
                    <button
                        key={r.id}
                        type="button"
                        className={`chip${activeRegions.includes(r.id) ? ' is-active' : ''}`}
                        aria-pressed={activeRegions.includes(r.id)}
                        onClick={() => onToggleRegion(r.id)}
                    >
                        {r.label}
                        <span className="chip__count">{r.count}</span>
                    </button>
                ))}
            </div>
        </div>

        <div className="filters__row">
            <span className="field__label">Source des données</span>
            <div className="chips">
                {sources.map(s => (
                    <button
                        key={s.id}
                        type="button"
                        className={`chip${activeSources.includes(s.id) ? ' is-active' : ''}`}
                        aria-pressed={activeSources.includes(s.id)}
                        onClick={() => onToggleSource(s.id)}
                        title={s.id === 'IRWIN' ? 'États-Unis' : 'Couverture mondiale'}
                    >
                        {s.id}
                        <span className="chip__count">{s.count}</span>
                    </button>
                ))}
            </div>
        </div>

        <div className="filters__row filters__row--inline">
            <label className="field__label" htmlFor="sort">Trier par</label>
            <select id="sort" value={sort} onChange={e => onSortChange(e.target.value)}>
                {SORTS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
            {isFiltered && (
                <button type="button" className="btn btn--link" onClick={onReset}>
                    Réinitialiser
                </button>
            )}
        </div>
    </div>
)

export default FilterPanel
